import {Component, Inject, OnInit, Optional} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import {IBankInfoCredential} from 'src/app/interfaces/accountant.interfaces';
import {DIALOG_DATA} from 'src/app/services/dialog.service';
import {DialogRef} from 'src/app/shared/ui-kits/dialog/dialog-ref';
import {Clipboard} from '@angular/cdk/clipboard';

import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {EmployeeService} from 'src/app/services/employee.service';
import {ToastrService} from 'ngx-toastr';

@UntilDestroy()
@Component({
  selector: 'app-autentification-credentials-popup',
  templateUrl: './autentification-credentials-popup.component.html',
  styleUrls: ['./autentification-credentials-popup.component.scss'],
})
export class AutentificationCredentialsPopupComponent implements OnInit {
  public credentialsForm!: UntypedFormGroup;
  public isCreate = false;

  constructor(
    private _fb: UntypedFormBuilder,
    private dialogRef: DialogRef,
    @Optional() @Inject(DIALOG_DATA) public data: IBankInfoCredential,
    private clipboard: Clipboard,
    private notifier: ToastrService,
    private employee: EmployeeService
  ) {}

  ngOnInit(): void {
    if (!this.data.id) {
      this.isCreate = true;
    }
    this.credentialsForm = this._fb.group({
      id: new UntypedFormControl(this.data.id),
      login: new UntypedFormControl(this.data.login),
      passwordFilePath: new UntypedFormControl(this.data.passwordFilePath),
      keyFilePath: new UntypedFormControl(this.data.keyFilePath),
      backupPasswordFilePath: new UntypedFormControl(
        this.data.backupPasswordFilePath
      ),
      backupKeyFilePath: new UntypedFormControl(this.data.backupKeyFilePath),
      cloudPasswordFilePath: new UntypedFormControl(
        this.data.cloudPasswordFilePath
      ),
      cloudKeyFilePath: new UntypedFormControl(this.data.cloudKeyFilePath),
      comment: new UntypedFormControl(this.data.comment),
      bankInfoId: new UntypedFormControl(this.data.bankInfoId),
    });
  }

  copyToClipboard(valueToCopy: string) {
    this.clipboard.copy(valueToCopy);
    this.notifier.success('Copied to clipboard');
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close(this.credentialsForm.value);
  }

  deleteCredential() {
    if (!this.data.id) return;
    this.employee
      .deleteCredential(this.data.id)
      .pipe(untilDestroyed(this))
      .subscribe(() => this.dialogRef.close('delete'));
  }
}
